// extracted by mini-css-extract-plugin
export var container = "_aq-0";
export var error = "_aq-9";
export var label = "_aq-5";
export var light = "_aq-6";
export var md = "_aq-3";
export var sm = "_aq-2";
export var thin = "_aq-8";
export var thinBold = "_aq-7";
export var vertical = "_aq-4";
export var xs = "_aq-1";